<template>
  <v-text-box class="box">
    <template #box-title>αξιζει να δειτε</template>
    <template #box-text>
      <ul class="list">
        <li>
          {{ text.li1 }}
        </li>
        <li>{{ text.li2 }}</li>
      </ul>
    </template>
  </v-text-box>
</template>

<script>
import VTextBox from '@/components/modules/VTextBox.vue';

export default {
  name: 'AgiosDoTextBox',
  components: {
    VTextBox,
  },
  data() {
    return {
      text: {
        li1:
          'Να επισκεφτείτε τις εκκλησίες του Αγίου Γεωργίου και της Αγίας Παρασκευής',
        li2:
          'Να επισκεφτείτε την παλαιότερη σωζόμενη κοινόχρηστη βρύση βορειοδυτικά του χωριού, την Τσέσμα, κτίσμα του 1626.',
      },
    };
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 45%;
}
.list {
  list-style: unset;
}

@media (max-width: 900px) {
  .box {
    width: 100%;
  }
}
</style>
